import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {
	selectSolarBase,
	selectSolarGenerators,
	selectSolarHeight,
	selectSolarLuminarCountValue,
	selectSolarLumPosition1,
	selectSolarLumPosition2
} from '../../solarSelectors';

@customElement('svg-aeto-drawing')
export class SvgAetoDrawing extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		  height: 100%;
	  }

	  svg {
		height: 100%;
		width: auto;
		margin: auto;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.solar = state.solar.data;
		this.status = state.status;
		this.luminarCount = selectSolarLuminarCountValue(this.state);
		this.generators = selectSolarGenerators(this.state);
		this.pos1 = selectSolarLumPosition1(this.state);
		this.pos2 = selectSolarLumPosition2(this.state);
		this.housingHeightValue = selectSolarHeight(this.state);
		this.housingHeight = this.housingHeightValue ? parseInt(this.housingHeightValue, 10) / 10 : 0;
		this.base = selectSolarBase(this.state);
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + 'visuals/aetoDrawing.svg';
		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" id="Aeto" width="679" height="8062" viewBox="0 0 679 8062" fill="none">
				<g id="AetoDrawing" transform="translate(339,1948) scale(0.5,0.5) translate(-677,-3896) translate(0,${-1 * (this.housingHeight-4) * 1830})">

					${when(this.generators >= 4, () => svg`
        				<g id="Module4" transform="translate(677,910.5) translate(-677,-910.5)">
							${when(this.luminarCount >= 2 && this.pos2 === 4, () => svg`
								<use href="${svgPath}#Module4_Left"></use>
							`)}
							${when(this.pos1 === 4, () => svg`
								<use href="${svgPath}#Module4_Right"></use>
							`)}
							<use href="${svgPath}#Module4_Panel"></use>
						</g>
					`)}

					${when(this.generators >= 3, () => svg`
						<g id="Module3" fill="none" filter="none" transform="translate(677,2731.5)">
							${when(this.luminarCount >= 2 && this.pos2 === 3, () => svg`
								<use href="${svgPath}#Module3_Left"></use>
							`)}
							${when(this.pos1 === 3, () => svg`
								<use href="${svgPath}#Module3_Right"></use>
							`)}
							<use href="${svgPath}#Module3_Panel"></use>
						</g>
					`)}

					${when(this.generators >= 2, () => svg`
						<g id="Module2" fill="none" filter="none" transform="translate(677,4553)">
							${when(this.luminarCount >= 2 && this.pos2 === 2, () => svg`
								<use href="${svgPath}#Module2_Left"></use>
							`)}
							${when(this.pos1 === 2, () => svg`
								<use href="${svgPath}#Module2_Right"></use>
							`)}
							<use href="${svgPath}#Module2_Panel"></use>
						</g>
					`)}

					${when(this.generators >= 1, () => svg`
						<g id="Module1" fill="none" filter="none" transform="translate(677,6373.85)">
							${when(this.luminarCount >= 2 && this.pos2 === 1, () => svg`
								<use href="${svgPath}#Module1_Left"></use>
							`)}
							${when(this.pos1 === 1, () => svg`
								<use href="${svgPath}#Module1_Right"></use>
							`)}
							<use href="${svgPath}#Module1_Panel"></use>
						</g>
					`)}
					<use href="${svgPath}#HS_HousingHeight_${this.housingHeightValue}"></use>
					<use href="${svgPath}#${this.base}" transform="translate(0,${(this.housingHeight-4)*1830})"></use>
				</g>
			</svg>
		`;
	}
}
